var exports = {
  "kL": "x8b4e8595--8e2719--container",
  "Qq": "x8b4e8595--8e2719--text",
  "b0": "x8b4e8595--8e2719--ticker",
  "$I": "x8b4e8595--8e2719--ticker--static",
  "xG": "x8b4e8595--8e2719--ticker--infinite",
  "p5": "x8b4e8595--8e2719--tickerInfinite",
};

module.exports = exports;
